import { useCallback, useEffect, useState } from 'react';

interface SedanPaintSVGProps {
  view: 'left' | 'top' | 'right';
  className?: string;
  onLoad?: () => void;
}

/**
 * Komponent SVG sedana dla widoku punktów pomiarowych lakieru
 *
 * Dynamicznie importuje odpowiedni plik SVG na podstawie widoku:
 * - left: svg/sedan-left.svg
 * - top: svg/all-center.svg (wspólny dla wszystkich typów)
 * - right: svg/sedan-right.svg
 */
export const SedanPaintSVG: React.FC<SedanPaintSVGProps> = ({
  view,
  className = '',
  onLoad,
}) => {
  const [IconComponent, setIconComponent] = useState<React.FC<React.SVGProps<SVGSVGElement>> | null>(null);

  const getSvgName = useCallback(() => {
    switch (view) {
      case 'left':
        return 'sedan-left';
      case 'top':
        return 'all-center';
      case 'right':
        return 'sedan-right';
      default:
        return 'sedan-left';
    }
  }, [view]);

  const importIcon = useCallback(async () => {
    try {
      const svgName = getSvgName();
      /* @vite-ignore */
      const imported = await import(`./svg/${svgName}.svg`);
      setIconComponent(() => imported.ReactComponent);
    } catch (error) {
      console.error('Błąd ładowania SVG sedana:', error);
    }
  }, [getSvgName]);

  useEffect(() => {
    importIcon();
  }, [importIcon]);

  useEffect(() => {
    if (IconComponent) {
      onLoad?.();
    }
  }, [IconComponent, onLoad]);

  if (!IconComponent) {
    return <div className={className} />;
  }

  return <IconComponent className={className} />;
};
